/* tslint:disable */
/* eslint-disable */
/**
 * RoadFootage.API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
import { BountyResponseStatusFromJSON, BountyResponseStatusToJSON, } from './BountyResponseStatus';
/**
 * Check if a given object implements the BountyResponseDto interface.
 */
export function instanceOfBountyResponseDto(value) {
    let isInstance = true;
    return isInstance;
}
export function BountyResponseDtoFromJSON(json) {
    return BountyResponseDtoFromJSONTyped(json, false);
}
export function BountyResponseDtoFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'id': !exists(json, 'id') ? undefined : json['id'],
        'bountyId': !exists(json, 'bountyId') ? undefined : json['bountyId'],
        'incidentReportId': !exists(json, 'incidentReportId') ? undefined : json['incidentReportId'],
        'status': !exists(json, 'status') ? undefined : BountyResponseStatusFromJSON(json['status']),
        'decisionReason': !exists(json, 'decisionReason') ? undefined : json['decisionReason'],
        'createdAt': !exists(json, 'createdAt') ? undefined : (new Date(json['createdAt'])),
        'decidedAt': !exists(json, 'decidedAt') ? undefined : (json['decidedAt'] === null ? null : new Date(json['decidedAt'])),
    };
}
export function BountyResponseDtoToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'id': value.id,
        'bountyId': value.bountyId,
        'incidentReportId': value.incidentReportId,
        'status': BountyResponseStatusToJSON(value.status),
        'decisionReason': value.decisionReason,
        'createdAt': value.createdAt === undefined ? undefined : (value.createdAt.toISOString()),
        'decidedAt': value.decidedAt === undefined ? undefined : (value.decidedAt === null ? null : value.decidedAt.toISOString()),
    };
}
